import React from 'react';
import './Footer.css';

function Footer() {
    const currentYear = new Date().getFullYear();

  return (
    <div className="footer">
        <p>© {currentYear} POJOBOX. Todos los derechos reservados.</p>
    </div>
  )
}

export default Footer